import { getMarketsListQueryOptions } from "@sidegigllc/api/client";

export const marketsQueryOptions = () =>
  getMarketsListQueryOptions(undefined, { query: { staleTime: Number.POSITIVE_INFINITY } });
